<template>
  <v-row class="ma-0">
    <v-sheet style="height: 100%; width: 100%">
      <v-container fluid>
        <v-form
          v-model="formValid"
          ref="form"
          lazy-validation
          :disabled="!canEdit"
        >
          <v-row align="center" class="ma-0">
            <v-col cols="2" class="details-header">Project</v-col>
            <v-col cols="10" md="6" class="py-2">
              <v-text-field
                placeholder="Project name"
                solo
                flat
                dense
                validate-on-blur
                v-model="editedProjectInfo.name"
                class="details-field px2"
                background-color="transparent"
                :hide-details="
                  rules.required(editedProjectInfo.name) === true ||
                  !projectInfoChanged
                "
                :rules="[rules.required]"
                required
              />
            </v-col>
            <v-spacer></v-spacer>
          </v-row>

          <v-row align-content="center" class="ma-0">
            <v-col cols="2" class="details-header">Brief</v-col>
            <v-col cols="10" md="6" class="py-2">
              <v-textarea
                solo
                flat
                dense
                v-model="editedProjectInfo.description"
                placeholder="Project description"
                class="details-field px2"
                background-color="transparent"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row align="center" class="ma-0">
            <v-col cols="2" class="details-header">Owners</v-col>
            <v-col cols="10" class="py-2">
              <v-row class="ma-0">
                <v-avatar
                  class="mx-1"
                  v-for="own in editedProjectInfo.owners"
                  :key="own.id"
                  color="grey"
                  >{{
                    getInitials([own.firstName, own.lastName].join(' '))
                  }}</v-avatar
                >
                <v-btn
                  fab
                  elevation="0"
                  color="primary"
                  max-width="50"
                  max-height="50"
                  class="mx-1"
                  v-if="canEdit"
                  @click="ownersSelectionVisible = !ownersSelectionVisible"
                  >+</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-sheet>
    <!-- </v-row>
  <v-row justify="center"> -->
    <v-dialog v-model="ownersSelectionVisible" max-width="600px" persistent>
      <selection-list
        title="Select project owners"
        :collectionRef="employeesCollectionRef"
        :headers="[
          {
            text: 'First name',
            value: 'firstName',
          },
          {
            text: 'Last name',
            value: 'lastName',
          },
        ]"
        v-model="editedProjectInfo.owners"
        @close="ownersSelectionVisible = false"
        :readOnlyId="false"
      ></selection-list>
    </v-dialog>
  </v-row>
</template>

<script>
import SelectionList from '@/components/SelectionList.vue'
import { textFieldRules, getInitials } from '@/common'
import { db } from '@/firebaseConfig'
import { mapActions, mapGetters } from 'vuex'
import {
  hasAccessRightForCollection,
  AccessRightWrite,
} from '@/plugins/feature'

export default {
  props: ['id', 'projectInfo'],
  components: {
    SelectionList,
  },
  data() {
    return {
      dateMenu: false,
      formValid: false,
      rules: textFieldRules,
      editedProjectInfo: { status: 'To do', owners: [] },
      ownersSelectionVisible: false,
      getInitials,
    }
  },
  created() {
    this.editedProjectInfo = Object.assign({}, this.projectInfo)
  },
  computed: {
    ...mapGetters(['companyId']),
    canEdit() {
      return hasAccessRightForCollection('projects', AccessRightWrite)
    },
    projectInfoChanged() {
      return (
        JSON.stringify(this.projectInfo) !==
        JSON.stringify(this.editedProjectInfo)
      )
    },
    collectionRef() {
      return db.collection(`companies/${this.companyId}/projects`)
    },
    employeesCollectionRef() {
      return db.collection(`companies/${this.companyId}/workforce`)
    },
  },
  watch: {
    formValid(formValid) {
      this.$emit(formValid ? 'valid' : 'invalid', formValid)
    },
    editedProjectInfo: {
      handler(editedProjectInfo) {
        this.$emit('update:editedProjectInfo', editedProjectInfo)
      },
      deep: true,
    },
    projectInfo: {
      handler() {
        this.editedProjectInfo = Object.assign({}, this.projectInfo)
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['showError', 'showDeletionSuccess']),
    selectDueDate(date) {
      this.editedProjectInfo.dueDate = date
      this.dateMenu = false
    },
  },
}
</script>
